import { c as _c } from "react/compiler-runtime";
import { E_COURSE_ITEM_API, PHYSICAL_PRODUCT_ITEM_API, PRODUCT_ITEM_API, getCourseItemPostPath, getPhysicalProductItemPostPath, getProductItemPostPath } from 'modules/stores/api/stores-api';
import { PhysicalProductItemUpdateType, PhysicalProductItemViewType, ProductDownloadItemUpdateType, ProductDownloadItemViewType, ProductECourseItemUpdateType, ProductECourseItemViewType } from 'modules/stores/store/content/product/types/product-interface';
import { usePublisherErrorHandler } from 'modules/stores/store/hooks/use-publisher-error-handler';
import { StoreId } from 'modules/stores/types/stores-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
export const useItemProductActions = () => {
  const $ = _c(41);
  const {
    internalErrorHandler
  } = usePublisherErrorHandler();
  let t0;
  if ($[0] !== internalErrorHandler) {
    t0 = {
      method: RequestMethodsEnum.post,
      unprocessableContentHandler: _temp,
      internalErrorHandler
    };
    $[0] = internalErrorHandler;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    fetcher: postFetcher
  } = useFetch(t0);
  let t1;
  if ($[2] !== internalErrorHandler) {
    t1 = {
      method: RequestMethodsEnum.put,
      unprocessableContentHandler: _temp2,
      internalErrorHandler
    };
    $[2] = internalErrorHandler;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    fetcher: putFetcher
  } = useFetch(t1);
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      method: RequestMethodsEnum.delete
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    fetcher: deleteFetcher
  } = useFetch(t2);
  let t3;
  if ($[5] !== internalErrorHandler) {
    t3 = {
      method: RequestMethodsEnum.post,
      unprocessableContentHandler: _temp3,
      internalErrorHandler
    };
    $[5] = internalErrorHandler;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    fetcher: postECourseFetcher
  } = useFetch(t3);
  let t4;
  if ($[7] !== internalErrorHandler) {
    t4 = {
      method: RequestMethodsEnum.put,
      unprocessableContentHandler: _temp4,
      internalErrorHandler
    };
    $[7] = internalErrorHandler;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const {
    fetcher: putECourseFetcher
  } = useFetch(t4);
  let t5;
  if ($[9] !== internalErrorHandler) {
    t5 = {
      method: RequestMethodsEnum.post,
      unprocessableContentHandler: _temp5,
      internalErrorHandler
    };
    $[9] = internalErrorHandler;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const {
    fetcher: postPhysicalProductFetcher
  } = useFetch(t5);
  let t6;
  if ($[11] !== internalErrorHandler) {
    t6 = {
      method: RequestMethodsEnum.put,
      unprocessableContentHandler: _temp6,
      internalErrorHandler
    };
    $[11] = internalErrorHandler;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const {
    fetcher: putPhysicalProductFetcher
  } = useFetch(t6);
  let t7;
  if ($[13] !== postFetcher) {
    t7 = (storeId, data) => postFetcher(getProductItemPostPath(storeId), data);
    $[13] = postFetcher;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const createProduct = t7;
  let t8;
  if ($[15] !== putFetcher) {
    t8 = (id, data_0) => putFetcher(`${PRODUCT_ITEM_API}/${id}`, data_0);
    $[15] = putFetcher;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const updateProduct = t8;
  let t9;
  if ($[17] !== deleteFetcher) {
    t9 = id_0 => deleteFetcher(`${PRODUCT_ITEM_API}/${id_0}`);
    $[17] = deleteFetcher;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const deleteProductItem = t9;
  let t10;
  if ($[19] !== postECourseFetcher) {
    t10 = (storeId_0, data_1) => postECourseFetcher(getCourseItemPostPath(storeId_0), data_1);
    $[19] = postECourseFetcher;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  const createECourse = t10;
  let t11;
  if ($[21] !== putECourseFetcher) {
    t11 = (id_1, data_2) => putECourseFetcher(`${E_COURSE_ITEM_API}/${id_1}`, data_2);
    $[21] = putECourseFetcher;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  const updateECourse = t11;
  let t12;
  if ($[23] !== deleteFetcher) {
    t12 = id_2 => deleteFetcher(`${E_COURSE_ITEM_API}/${id_2}`);
    $[23] = deleteFetcher;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  const deleteECourseItem = t12;
  let t13;
  if ($[25] !== postPhysicalProductFetcher) {
    t13 = (storeId_1, data_3) => postPhysicalProductFetcher(getPhysicalProductItemPostPath(storeId_1), data_3);
    $[25] = postPhysicalProductFetcher;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  const createPhysicalProduct = t13;
  let t14;
  if ($[27] !== putPhysicalProductFetcher) {
    t14 = (id_3, data_4) => putPhysicalProductFetcher(`${PHYSICAL_PRODUCT_ITEM_API}/${id_3}`, data_4);
    $[27] = putPhysicalProductFetcher;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  const updatePhysicalProduct = t14;
  let t15;
  if ($[29] !== deleteFetcher) {
    t15 = id_4 => deleteFetcher(`${PHYSICAL_PRODUCT_ITEM_API}/${id_4}`);
    $[29] = deleteFetcher;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  const deletePhysicalProductItem = t15;
  let t16;
  if ($[31] !== createECourse || $[32] !== createPhysicalProduct || $[33] !== createProduct || $[34] !== deleteECourseItem || $[35] !== deletePhysicalProductItem || $[36] !== deleteProductItem || $[37] !== updateECourse || $[38] !== updatePhysicalProduct || $[39] !== updateProduct) {
    t16 = {
      createProduct,
      updateProduct,
      deleteProductItem,
      createECourse,
      updateECourse,
      deleteECourseItem,
      createPhysicalProduct,
      updatePhysicalProduct,
      deletePhysicalProductItem
    };
    $[31] = createECourse;
    $[32] = createPhysicalProduct;
    $[33] = createProduct;
    $[34] = deleteECourseItem;
    $[35] = deletePhysicalProductItem;
    $[36] = deleteProductItem;
    $[37] = updateECourse;
    $[38] = updatePhysicalProduct;
    $[39] = updateProduct;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  return t16;
};
function _temp() {}
function _temp2() {}
function _temp3() {}
function _temp4() {}
function _temp5() {}
function _temp6() {}